import httpService from '@Utils/httpService';

const baseUrl = 'api/Management/moduleactivitylogs';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getByCompanyId(id, params = {}) {
    return httpService.get({
      url: `${baseUrl}/ByCompany/${id}`,
      params,
    });
  },
  getSummary(companyIds) {
    // Convert array to multiple query parameters with the same name
    const params = new URLSearchParams();
    if (Array.isArray(companyIds)) {
      companyIds.forEach(id => {
        if (id) params.append('companyIds', id);
      });
    }
    
    return httpService.get({
      url: `${baseUrl}/Summary/ByCompany`,
      params,
    });
  },
   
};
